import { useCallback } from 'react';

import { STORAGE_HOST_API_MINIO, STORAGE_HOST_API_R2, STORAGE_R2_PREFIX } from 'src/config-global';
import { FileSource } from 'src/types';

import { useActivePlatform } from './use-active-platform';

export const useFileLink = () => {
  const { platform } = useActivePlatform();

  const getFileLink = useCallback(
    (filePath: string | undefined, bucketName?: string, fileSource?: FileSource) => {
      if (!filePath) return '';
      if (filePath.startsWith('http://') || filePath.startsWith('https://')) return filePath;

      const isR2 = fileSource
        ? fileSource === 'cloudflare'
        : filePath.startsWith(STORAGE_R2_PREFIX);
      const bucket = bucketName ?? platform?.bucket_name;
      const storage = isR2 ? STORAGE_HOST_API_R2 : STORAGE_HOST_API_MINIO;

      return `${storage}/${bucket}/${filePath}`;
    },
    [platform?.bucket_name]
  );

  return getFileLink;
};
